import { commonMessages } from '../../../util/messages'

export const isinMessages = {
  common: commonMessages,
  isinRating: {
    update: {
      success: 'ISIN rating successfuly updated',
      error: 'Error updating ISIN Rating',
    },
  },
}
